import { useSidebarPinState } from '@backstage/core-components';
import { Tooltip, IconButton } from '@material-ui/core';
import { RiSideBarFill, RiSideBarLine } from '@remixicon/react';

export const SidebarToggle = () => {
  const { isPinned, toggleSidebarPinState } = useSidebarPinState();

  return (
    <Tooltip
      title={`${isPinned ? 'Unpin' : 'Pin'} sidebar`}
      placement="bottom"
      PopperProps={{
        modifiers: {
          offset: { offset: '0, -6' },
        },
      }}
    >
      <IconButton onClick={() => toggleSidebarPinState()} size="small">
        {isPinned ? <RiSideBarFill /> : <RiSideBarLine />}
      </IconButton>
    </Tooltip>
  );
};
